
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export type RoofingBrand = {
  id: string;
  brand_name: string;
  top_products: string[];
  warranty_info: string;
  website_url: string;
  seo_keywords: string[];
  logo_url: string | null;
  display_order: number | null;
  created_at: string;
  updated_at: string;
};

// Fetch all roofing brands
export const useRoofingBrands = () => {
  return useQuery({
    queryKey: ['roofingBrands'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('roofing_brands')
        .select('*')
        .order('display_order', { ascending: true });

      if (error) throw new Error(error.message);
      return data as RoofingBrand[];
    },
  });
};
